import React, { useEffect } from 'react';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { CreateUpdateExamDto } from '../../../common/spdCore/autogenerated/spdApiClient';

export const ExamSpecialistEndedLink = (props: {
  examId: string | undefined;
  examNumber: number | undefined;
  specialistEnded: boolean | null | undefined;
  specialist: string;
  textVersion1: string;
  textVersion2: string;
  onChange?: () => void;
}) => {
  const notifications = useNotifications();
  const spd = useSpdCore();
  const [specialistEnded, setSpecialistEnded] = React.useState(
    props.specialistEnded,
  );

  useEffect(() => {
    setSpecialistEnded(props.specialistEnded);
  }, [props.specialistEnded]);

  const handleOnEnded = async () => {
    if (props.examId) {
      let updateField: CreateUpdateExamDto = {};
      switch (props.specialist) {
        case 'ophthalmologist':
          updateField = { ophthalmologistEnded: true };
          break;
        case 'laryngologist':
          updateField = { laryngologistEnded: true };
          break;
        case 'neurologist':
          updateField = { neurologistEnded: true };
          break;
        case 'psychiatrist':
          updateField = { psychiatristEnded: true };
          break;
      }
      notifications.onPromise(
        spd.exams.update(props.examId, updateField).then(() => {
          setSpecialistEnded(true);
          if (props.onChange) {
            props.onChange();
          }
        }),
      );
    }
  };
  const handleOnStart = async () => {
    if (props.examId) {
      let updateField: CreateUpdateExamDto = {};
      switch (props.specialist) {
        case 'ophthalmologist':
          updateField = { ophthalmologistEnded: false };
          break;
        case 'laryngologist':
          updateField = { laryngologistEnded: false };
          break;
        case 'neurologist':
          updateField = { neurologistEnded: false };
          break;
        case 'psychiatrist':
          updateField = { psychiatristEnded: false };
          break;
      }
      notifications.onPromise(
        spd.exams.update(props.examId, updateField).then(() => {
          setSpecialistEnded(false);
          if (props.onChange) {
            props.onChange();
          }
        }),
      );
    }
  };

  return (
    <div>
      {!specialistEnded && (
        <ConfirmationButton
          className="ms-1"
          confirmation={`Czy na pewno oznaczyć badanie ${
            props.examNumber || ''
          } jako zakończone od strony ${props.textVersion1}?`}
          variant="outline-danger"
          onOK={handleOnEnded}
        >
          Zakończ badanie {props.textVersion2}
        </ConfirmationButton>
      )}
      {specialistEnded && (
        <ConfirmationButton
          className="ms-1"
          confirmation={`Czy na pewno oznaczyć badanie ${
            props.examNumber || ''
          } jako potrzebujące obsługi od strony ${props.textVersion1}?`}
          variant="outline-primary"
          onOK={handleOnStart}
        >
          Wznów badanie {props.textVersion2}
        </ConfirmationButton>
      )}
    </div>
  );
};
